import type { GetterClass, TaggingData, TaggingState } from '../../../models'

export class DataGetter implements GetterClass {
  static execute(this: void, state: TaggingState): TaggingData {
    return state.data
  }
}
